import {
	SELECTING_SITE_ID,
	SELECTING_DIRECTORY,
	SELECTING_ELEMENTS,
	SELECTING_SERVER_ID
} from '../../constants/selectedElement';

const selectedSiteId = (data) => {
	return {
		type: SELECTING_SITE_ID,
		payload: data
	};
};

const selectedDirectory = (data) => {
	return {
		type: SELECTING_DIRECTORY,
		payload: data
	};
};

const selectElements = (data) => {
	return {
		type: SELECTING_ELEMENTS,
		payload: data
	};
};

const selectedServersId = (data) => {
	return {
		type: SELECTING_SERVER_ID,
		payload: data
	};
};

export { selectedSiteId, selectedDirectory, selectElements, selectedServersId };
